import React, { FC } from 'react'
import { ButtonProps } from './types'
import { ButtonStyle } from './Button.styles'
import Icon from '../../Core/Iconography/Icon/Icon'
import Spinner from 'src/components/Core/Loading/Spinner/Spinner'

const Button: FC<ButtonProps> = props => (
  <ButtonStyle
    {...props}
  >
    {props.isLoading && (
      <Spinner buttonMode />
    )}
    {props.iconName && !props.isLoading && (
      <Icon
        name={props.iconName}
        color={props.version === 2 ? (props.color || 'main') : 'blank'}
      />
    )}
    {props.label}
  </ButtonStyle>
)

Button.defaultProps = {
  iconName: '',
  label: '',
  type: 'button',
  version: 1,
  disabled: false,
}

export default Button
